import React from "react";
import PropTypes from "prop-types";
import styles from "./PricingOption.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";

export default function PricingOption({
  packageName,
  priceMonthly,
  priceAnnual,
  onMonthly,
  onAnnual,
  sections,
  isBundle,
  savings,
  note,
  currentSelected,
}) {
  const isMonthlySelected = currentSelected == "monthly";
  const isAnnualSelected = currentSelected == "annual";

  return (
    <>
      <div className={styles.container}>
        {sections.map((item, index) => (
          <div className={styles.section} key={index}>
            {item.section.logo.length > 0 ? (
              <img
                className={styles.image}
                src={require(`../../assets/${item.section.logo}`)}
                alt="logo"
              ></img>
            ) : (
              <></>
            )}

            <h4 className={styles.header}>{item.section.header}</h4>
            <div className={styles.row}>
              <ul>
                {item.section.features != null ? (
                  item.section.features.map((feature, index) => (
                    <li key={index}>
                      <FontAwesomeIcon icon={faCheck} className={styles.icon} />
                      {feature.feature}{" "}
                      <span style={{ fontWeight: "bold" }}>
                        {feature.isNew}
                      </span>
                    </li>
                  ))
                ) : (
                  <></>
                )}
              </ul>
              {isBundle && item.section.features.length > 0 ? (
                <div className={styles.bundleTag}>
                  <small>
                    Save
                    <br />
                    {savings}
                  </small>
                </div>
              ) : (
                <></>
              )}
            </div>
          </div>
        ))}
        {note.length > 0 ? (
          <small className={styles.note}>{note}</small>
        ) : (
          <></>
        )}

        <div className={styles.paymentOptions}>
          <div className={styles.row}>
            <div className={styles.column}>
              <p className={styles.bold}>{packageName}</p>
              <small>${priceMonthly} Monthly Subscription</small>
            </div>
            <button
              className={`${styles.button} ${
                isMonthlySelected && styles.selectedButton
              }`}
              onClick={!isMonthlySelected ? onMonthly : undefined}
              disabled={isMonthlySelected}
            >
              {isMonthlySelected ? "Current" : "Sign Up"}
            </button>
          </div>
          <div className={styles.row}>
            <div className={styles.column}>
              <p className={styles.bold}>{packageName}</p>
              <small>${priceAnnual} Annual Subscription</small>
            </div>
            <button
              className={`${styles.button} ${
                isAnnualSelected && styles.selectedButton
              }`}
              onClick={!isAnnualSelected ? onAnnual : undefined}
              disabled={isAnnualSelected}
            >
              {isAnnualSelected ? "Current" : "Sign Up"}
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

PricingOption.propTypes = {
  packageName: PropTypes.string.isRequired,
  priceMonthly: PropTypes.string.isRequired,
  priceAnnual: PropTypes.string.isRequired,
  onMonthly: PropTypes.func.isRequired,
  onAnnual: PropTypes.func.isRequired,
  sections: PropTypes.arrayOf(
    PropTypes.shape({
      section: PropTypes.shape({
        logo: PropTypes.string,
        header: PropTypes.string,
        features: PropTypes.arrayOf(
          PropTypes.shape({
            feature: PropTypes.string,
            isNew: PropTypes.string,
          })
        ),
      }),
    })
  ),
  isBundle: PropTypes.bool,
  savinsg: PropTypes.string,
  note: PropTypes.string,
};
